import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q83zsr8m4m: FaireBrandEntity = {
  token: "b_q83zsr8m4m",
  type: "brand",
  name: "MILIO MILANO",
  avatarUrl:
    "https://cdn.faire.com/fastly/0680783b32b39a3fa0a4673b1534f4364511e56e1859886ae000485547747430.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/149e56bc239455bcf99406a40ac05c3ab01fec01228e1b719961c5e93ec15889.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0680783b32b39a3fa0a4673b1534f4364511e56e1859886ae000485547747430.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/149e56bc239455bcf99406a40ac05c3ab01fec01228e1b719961c5e93ec15889.png",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.6,
  reviewCount: 114,
  isInsider: true,
  description:
    "Welcome to Milio Milano wholesale!\n\n     We are a classic contemporary brand manufactured in Italy, dedicated to giving you the very best quality, design and customer service experience.\nWe have over 30 years of experience in the fashion industry and started Milio Milano to incorporate our knowledge, hard work and passion for excellence in producing beautiful pieces out of quality fabrics such as linen, cotton, silk, and viscose to name a few. We serve customers all over the US, Italy, France and worldwide. We are thrilled to be a part of the fascinating, constantly changing fashion industry. We believe in the integrity of sustainable production and we hope you enjoy our products as much as we enjoy offering them to you.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:49.441Z",
    importedBy: "entity-db-cli",
  },
};
